import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingBarChartWidget } from '../../bar-chart-widget/bar-chart-widget.component';
import { EveReportingWidgetDataSourceType } from '../../widget-menu-settings/widget-datasource/widget-datasource.component';

import { Color/*, colorSets */} from '@swimlane/ngx-charts/lib/utils/color-sets'
import { ScaleType } from '@swimlane/ngx-charts';


@Component({
  selector: 'bar-chart-widget-menu-settings',
  templateUrl: 'bar-chart-widget-menu-settings.component.html',
  styleUrls: ['./bar-chart-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class BarChartWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingBarChartWidget = null;

  


  constructor(

  ) {


  }

  ngOnInit(): void {
    //TODO: this isnt right
    if (this.widget.dataSource?.type != EveReportingWidgetDataSourceType.EveMultiChart) this.widget.dataSource = {
      type: EveReportingWidgetDataSourceType.EveMultiChart
    };
  }


}


